import { CommonModule } from '@angular/common';
import { Component, ElementRef, ViewChild, ViewContainerRef } from '@angular/core';
import { Modal } from 'bootstrap';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'add-issue',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './add-issue.component.html',
  styleUrls: ['./add-issue.component.css']
})
export class AddIssueComponent {
  data = {
    textarea: {
      placeholder: "What's Your Post/Issue?",
      rows: 1
    },
    buttons: [
      { label: 'Upload Image', icon: 'bi bi-image', type: 'image' },
      { label: 'Upload Video', icon: 'bi bi-camera-reels', type: 'video' },
      { label: 'Upload Document', icon: 'bi bi-file-earmark', type: 'document' }
    ],
  };

constructor(private view: ViewContainerRef) {}

  // Open modal dynamically based on interaction
  openModal(source: string) {
    console.log(window.location.href);
    const currentUrl = window.location.href;

    // Create a URL object to parse the URL
    const queryString = currentUrl.split('?')[1]; // Get the part after '?'
    let issueType = null;

    if (queryString) {
        const params = queryString.split('&'); // Split by '&' to get key-value pairs

        for (const param of params) {
            const [key, value] = param.split('='); // Split each pair by '='
            if (key === 'issuetype') {
                issueType = decodeURIComponent(value);
                break;
            }
        }
    }
    if (issueType) {
        console.log(`Issue Type Selected: ${issueType}`);
    } else {
        console.log("Issue Type not found in URL");
    }
     console.log(`Clicked on: ${source}`);

    const customEvent = new CustomEvent('modal', {
      bubbles: true,
      cancelable: true,
      detail: {
        data: {
          formId: "67a08cb0cc7cfb3daa2d5923",
          data:{
            issueType: issueType,
          }
        },
        config:{
          isModal: true
        }
      }
    });
  
    this.view.element.nativeElement.dispatchEvent(customEvent);
  }
  

}
